import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accident-death',
  templateUrl: './accident-death.component.html',
  styleUrls: ['./accident-death.component.scss']
})
export class AccidentDeathComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
